var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59391 10C3.5469 10 3.50071 9.98782 3.45991 9.96466C3.41912 9.9415 3.38514 9.90817 3.36134 9.86798C2.46529 8.35458 0.0764434 5.1321 0.0524424 5.09972C0.0140672 5.048 -0.00425223 4.98432 0.000833017 4.92031C0.00591826 4.8563 0.0340685 4.79625 0.0801379 4.75112L0.814702 4.03146C0.859565 3.98751 0.918548 3.96054 0.981391 3.95524C1.04424 3.94994 1.10696 3.96665 1.15867 4.00245L3.53779 5.64935C5.12978 3.62549 6.60856 2.22723 7.58144 1.40216C8.67674 0.473428 9.37399 0.0553152 9.40316 0.0380977C9.44508 0.0131678 9.49303 -7.76455e-07 9.54191 5.41362e-10H10.7303C10.785 -3.44776e-06 10.8384 0.0164666 10.8834 0.0472265C10.9284 0.0779863 10.9629 0.121583 10.9824 0.172237C11.0018 0.222891 11.0053 0.278209 10.9923 0.330858C10.9793 0.383506 10.9505 0.430999 10.9096 0.467038C7.53486 3.44706 3.8649 9.80112 3.82823 9.86496C3.80481 9.90571 3.771 9.93964 3.73017 9.96334C3.68935 9.98703 3.64296 9.99967 3.59566 9.99997L3.59391 10Z",
    fill: "#183243"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMarkIcon);
export default __webpack_public_path__ + "static/media/tickMarkIcon.2ccb993a7972b11fb656419a28ab279d.svg";
export { ForwardRef as ReactComponent };